//* Third Party Libraries
import React, { useState, useMemo } from "react";

//* Local or Custom Libraries
import StoryProductTile from "@lululemon/ecom-story/src/components/story-product-tile/story-product-tile";
import { useDeviceType } from "@lululemon/ecom-site/src/util/with-device-characteristics";
import { Button } from "@lululemon/ui-library";
import { getProductPricing } from "./utilities";
import { usePDPState } from "../../context/PDPRoot.context";
import usePDPTranslations from "../../hooks/useTranslations";

//* Importing Styles
import styles from "./recommenders-grid-styles.module.scss";

const SHOWN_ITEMS_FOR_DESKTOP = 8;
const SHOWN_ITEMS_FOR_MOBILE = 4;

const RecommendersGrid = () => {
  const { pdpState } = usePDPState();
  const { deviceType } = useDeviceType();
  const translations = usePDPTranslations();

  const title = translations?.labels?.youMayAlsoLike || "You may also like";
  const isDesktop = deviceType?.isDesktop || false;

  const records = useMemo(
    () =>
      (pdpState?.recommendationItems || []).map((product) => ({
        ...product,
        "repository-id": product["product-id"],
        "product-sale-price": product["sale-price"],
      })),
    [pdpState?.recommendationItems]
  );

  /// TODO: Determine if this should be deviceType dependent or should import useIsYmlVerticalEnabled
  const productsToShowInitially = isDesktop
    ? SHOWN_ITEMS_FOR_DESKTOP
    : SHOWN_ITEMS_FOR_MOBILE;

  const [visibleItems, setVisibleItems] = useState(productsToShowInitially);
  const isViewMoreButtonVisible = records.length > visibleItems;

  const visibleRecords = useMemo(
    () => records.slice(0, visibleItems),
    [records, visibleItems]
  );

  const showAllItems = () => {
    setVisibleItems(records.length);
  };

  return (
    <section
      id="youMayAlsoLikeContainer"
      className={`wrapper ${styles.youMayAlsoLikeContainer}`}
    >
      <h2 className={`${styles.label}`}>{title}</h2>
      <div className={`${styles.productsContainer}`}>
        {visibleRecords.map((product, index) => (
          <StoryProductTile
            key={`product-${product?.id || index}`}
            analyticsComponentLinkAttr={"story-carousel"}
            headingLevel={"h3"}
            product={product}
            price={getProductPricing(product)}
            index={index}
            tileType={"story-carousel-tile"}
            resize="story_carousel"
            isMobileDevice={!isDesktop}
            dataType={"you may also like"}
            hideSwatches={false}
          />
        ))}
      </div>
      {isViewMoreButtonVisible && (
        <div className={styles.footer}>
          <p className={styles.counter}>
            Viewing {productsToShowInitially} from {records.length}
          </p>
          <Button variant="outline" onClick={showAllItems}>
            View More Products
          </Button>
        </div>
      )}
    </section>
  );
};

export default RecommendersGrid;
